import type { GroupResponsibleState, GroupResponsibleStore } from '@/scopes/account/group-responsible/domain/types'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand'

const defaultInitialState: GroupResponsibleState = {
  bookingData: {
    group: {
      name: '',
      imgSrc: '',
      location: '',
      period: '',
      startingDate: '',
    },
    labels: [{ text: '', type: 'info' }],
  },
  activeTab: 'participants',
  participants: {},
  rooms: {},
  buses: {},
  activeExtraInfoId: '',
  selectedParticipantIds: new Set(),
  isEditingParticipants: false,
  retrieveBookingData: {
    loading: true,
    error: false,
  },
  busPickupPoints: [
    { id: '1', name: 'Central Station' },
    { id: '2', name: 'Airport' },
  ],
  busReturnPoints: [
    { id: '1', name: 'Central Station' },
    { id: '2', name: 'Airport' },
  ],
  busAssignment: {
    selectedPickupPointId: '',
    selectedReturnPointId: '',
    sameAsPickup: true,
    submitting: false,
    error: false,
    pickupPointNotSelected: false,
    returnPointNotSelected: false,
  },
}

export const groupResponsibleStore = createGroupResponsibleStore()

export function createGroupResponsibleStore(initialState: GroupResponsibleState = defaultInitialState) {
  return createStore<GroupResponsibleStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as GroupResponsibleState)
    },

    changeTab: (tab) => {
      set(state => ({ ...state, activeTab: tab }))
    },

    changeExtraInfoId: (id) => {
      set(state => ({ ...state, activeExtraInfoId: id }))
    },

    toggleParticipantSelection: (participantId: string) => {
      set((state) => {
        const newSelectedIds = new Set(state.selectedParticipantIds)
        if (newSelectedIds.has(participantId)) {
          newSelectedIds.delete(participantId)
        }
        else {
          newSelectedIds.add(participantId)
        }
        return { ...state, selectedParticipantIds: newSelectedIds }
      })
    },

    selectAllParticipants: (participantIds: string[]) => {
      set(state => ({ ...state, selectedParticipantIds: new Set(participantIds) }))
    },

    clearAllSelections: () => {
      set(state => ({ ...state, selectedParticipantIds: new Set() }))
    },

    toggleIsEditingParticipants: (isEditing: boolean) => {
      set(state => ({ ...state, isEditingParticipants: isEditing }))
    },
  }))
}
